<template>
  <v-btn class="my-2" dark color="teal" @click="pushRoute" fab right bottom fixed>
    <v-icon dark>mdi-arrow-left</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: "BackToListBtn",

  props: {
    route: {
      type: String,
      default: ""
    },
    customLabel: {
      type: String,
      default: "Back to List"
    }
  },

  methods: {
    pushRoute() {
      //this.$router.push(this.route);
      this.$router.back();
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/gt/shared/BackToListBtn.vue